export const initialState = {
    is_loading: true,
    total_jobs: 0,
    total_pages: 0,
    current_page: 1,
    ftm: {},
    jobs_list: [],
    sort_key: '',
    sort_direction: ''
}